/*!
 * Application Insights JavaScript SDK - Web Analytics, 2.5.5
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


import '@microsoft/applicationinsights-shims';
export { ApplicationInsights } from "./JavaScriptSDK/ApplicationInsights";
//# sourceMappingURL=applicationinsights-analytics-js.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@microsoft/applicationinsights-analytics-js/dist-esm/applicationinsights-analytics-js.js
// module id = 132
// module chunks = 1